import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
export function Audience() {
  return <section className="py-24 bg-[#faf8f5]" data-id="element-10">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-11">
        <FadeIn data-id="element-12">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-16 text-[#1a1f3a]" data-id="element-13">
            Para quién es{' '}
            <span className="text-gray-400 font-sans text-2xl font-normal" data-id="element-14">
              (y para quién no)
            </span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-15">
          <FadeIn delay={200} data-id="element-16">
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-[#8da399] h-full" data-id="element-17">
              <h3 className="text-xl font-bold mb-6 flex items-center text-[#1a1f3a]" data-id="element-18">
                <span className="bg-[#8da399] text-white p-1 rounded-full mr-3" data-id="element-19">
                  <Check className="w-4 h-4" data-id="element-20" />
                </span>
                Es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-21">
                {['Te sientes cansada aunque “no deberías”', 'Quieres claridad mental y energía estable', 'Odias los extremos', 'Necesitas algo que encaje en una vida llena'].map((item, i) => <li key={i} className="flex items-start text-gray-600" data-id="element-22">
                    <Check className="w-5 h-5 text-[#8da399] mr-3 flex-shrink-0 mt-0.5" data-id="element-23" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={400} data-id="element-24">
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-[#1a1f3a] h-full opacity-90" data-id="element-25">
              <h3 className="text-xl font-bold mb-6 flex items-center text-[#1a1f3a]" data-id="element-26">
                <span className="bg-[#1a1f3a] text-white p-1 rounded-full mr-3" data-id="element-27">
                  <X className="w-4 h-4" data-id="element-28" />
                </span>
                No es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-29">
                {['Buscas milagros en 48 horas', 'Quieres una dieta rígida', 'No estás dispuesta a hacer microajustes diarios'].map((item, i) => <li key={i} className="flex items-start text-gray-500" data-id="element-30">
                    <X className="w-5 h-5 text-[#1a1f3a] mr-3 flex-shrink-0 mt-0.5" data-id="element-31" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}